<template>
    <div class="userinfo clearfix">
        <div class="current">
            <p>当前位置：首页>我的</p>
        </div>
        <div class="menu">
            <center-menu active="1" />
        </div>
        <div class="content">
            <el-tabs v-model="activeName">
				<el-tab-pane label="用户信息" name="userinfo">
					<div>
						<p>用户姓名：{{userinfodata.chineseName}}</p>
						<p>手机：{{userinfodata.phone}}</p>
						<!-- <p>QQ：{{userinfodata.phone}}</p> -->
						<p>邮箱：{{userinfodata.email}}</p>
						<p>身份证号：{{userinfodata.documentNo}}</p>
					</div>
				</el-tab-pane>
				<el-tab-pane label="修改用户信息" name="modifyuseinfo">
						<el-form :model="enrollInfo" :rules="enrollRules" ref="enrollInfo" label-width="100px" label-position="right" @submit.native.prevent>
						    <el-form-item label="姓名:"  prop="chineseName">
						        <el-input v-model="enrollInfo.chineseName" placeholder="请输入真实姓名"></el-input>
						    </el-form-item>
							<el-form-item label="性别:"  prop="sex">
							    <el-radio-group v-model="enrollInfo.sex">
							        <el-radio :label="1">男</el-radio>
							        <el-radio :label="2">女</el-radio>
							    </el-radio-group>
							</el-form-item>
							<el-form-item label="手机:"  prop="phone">
							    <el-input v-model="enrollInfo.phone" placeholder="请输入手机号码"></el-input>
							</el-form-item>
							<el-form-item label="QQ:" prop="qq" >
							    <el-input v-model="enrollInfo.qq" placeholder="请输入QQ号码"></el-input>
							</el-form-item>
							<el-form-item label="邮箱:" prop="email" >
							    <el-input v-model="enrollInfo.email" placeholder="请输入邮箱"></el-input>
							</el-form-item>
							 <el-form-item label="证件类型:" prop="documentType">
							    <el-select clearable v-model="enrollInfo.documentType" placeholder="请选择证件类型">
							        <el-option
							            v-for="item in ggggList"
							            :key="item.value"
							            :label="item.label"
							            :value="item.value">
							        </el-option>
							    </el-select>
							</el-form-item>
							 <el-form-item label="证件号码:" prop="documentNo">
							    <el-input v-model="enrollInfo.documentNo" placeholder="请输入证件号码"></el-input>
							</el-form-item>
						</el-form>
						<div class="buttons">
						    <el-button :loading="submitLoading" @click="next(true)">提交</el-button>
						    <el-button :loading="saveLoading" @click="next(false)">重置</el-button>
						</div>
				</el-tab-pane>
				<el-tab-pane label="修改密码" name="modifypsw" class="zh">
					<el-form :model="zhTelInfo" :rules="zhTelRules" ref="zhTel" label-width="100px" @submit.native.prevent>
					    <el-form-item prop="phone" label="手机号：">
					        <el-input disabled v-model="zhTelInfo.phone" placeholder="请输入注册时手机号"></el-input>
					    </el-form-item>
					    <el-form-item prop="code" class="code" label="验证码：">
					        <el-input v-model="zhTelInfo.code" placeholder="请输入验证码" style="margin-right: 20px;"></el-input>
					        <send-code
					            type="primary"
					            v-model="sendCodeLoading" 
					            @click.native="sendCode"
					            init-str="获取验证码"
					            storageKey="zhSendCode31"
					            second="60"
					        ></send-code>
					    </el-form-item>
					    <el-form-item prop="newPwd" label="新密码：">
					        <el-input v-model="zhTelInfo.newPwd" placeholder="请输入新密码"></el-input>
					    </el-form-item>
					    <el-form-item prop="newPwd1" label="确认密码：">
					        <el-input v-model="zhTelInfo.newPwd1" placeholder="请再输入一次"></el-input>
					    </el-form-item>
					</el-form>

						<!-- <el-form :model="modifyPsw" :rules="modifyPswRules" ref="modifyPswInfo" label-width="100px" label-position="right" @submit.native.prevent>
						    <el-form-item  class="getcode" label="手机号:"  prop="phone">
						        <el-input v-model="modifyPsw.phone" placeholder="请输入手机号"></el-input>
								<send-code 
								    type="primary"
								    v-model="sendCodeLoading" 
								    @click.native="sendCode"
								    init-str="点击获取验证码"
								    storageKey="modifyPswSendCode"
								    second="60"
								></send-code>
						    </el-form-item>
							<el-form-item label="验证码:"  prop="code">
							    <el-input v-model="modifyPsw.code" placeholder="请输入验证码"></el-input>
							</el-form-item>
							<el-form-item label="新密码:"  prop="newPwd">
							    <el-input type="password" v-model="modifyPsw.newPwd" placeholder="请输入密码"></el-input>
							</el-form-item>
							<el-form-item label="确认密码:" prop="ddddd" >
							    <el-input type="password" v-model="modifyPsw.ddddd" placeholder="请确认密码"></el-input>
							</el-form-item>
						</el-form> -->
					<div class="buttons">
					    <el-button :loading="submitLoading" @click="next(1)">提交</el-button>
					</div>
				</el-tab-pane>
			</el-tabs>
        </div>
    </div>
</template>

<script>
import sendCode from '@/components/sendCode/sendCode'
import { loginGetCode,loginForget } from '@/api/user'
import { userGetUserInfo,userUpdate } from '@/api/center'
import validTools from '@/utils/validTools'
export default {
    name: 'userinfo',
    components: {
        sendCode
    },
    data(){
		let iiiiRules = (rule, value, callback) => {
		    if(this.modifyPsw.newPwd === this.modifyPsw.ddddd){
		        return callback()
		    }else{
		        return callback(new Error('两次密码不一致'))
		    }
		}
		let phoneRules =  (rule, value, callback) => {
		    validTools('mobile', value, callback, '', false)
		}
		let pwdRules =  (rule, value, callback) => {
		    if(this.zhTelInfo.newPwd == value){
		        return callback()
		    }else{
		        return callback(new Error('两次密码不一致'))
		    }
		}
        return {
        	zhTelInfo: {
        	    phone: '',
        	    code: '',
        	    newPwd: '',
        	    newPwd1: '',
        	},
        	zhTelRules: {
                phone: [
                    { required: true, message: '请输入手机号'},
                    { validator: phoneRules, trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
                newPwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                newPwd1: [
                    { required: true, message: '请再次输入'},
                    { validator: pwdRules, trigger: 'blur' }
                ],
            },
			activeName:"userinfo",
			submitLoading: false,
			sendCodeLoading: false,
			saveLoading: false,
			ggggList: [
			    { label: '身份证', value: 1 },
			    { label: '护照', value: 2 },
				{ label: '台湾居民来大陆通行证', value: 3 },
				{ label: '香港身份证', value: 4 },
				{ label: '其他', value: -1 },
			],
			userinfodata:{},
			modifyPsw:{
				phone:"",
				code:"",
				newPwd:"",
				ddddd:""
			},
			enrollInfo: {
			    // chineseName: '',
			    // sex: '',
			    // phone:null,
			    // qq:null,
			    // email:null,
				id:this.$store.getters.userInfo.id,
			    // documentType: null,
			    // documentNo: null,
			},
			modifyPswRules:{
				ddddd:[
					{  validator: iiiiRules, trigger: 'blur' },
				]
			},
            enrollRules: {

            }
        }
    },
    mounted(){
        this.$emit('changeIndex',1)
		userGetUserInfo({}).then(res=>{
			this.userinfodata=res
			this.zhTelInfo.phone = this.userinfodata.phone
		})
    },
    methods:{
        next(val){
        	if(val === 1){
        		this.$refs['zhTel'].validate((valid) => {
                    if (valid){
                        this.submitLoading = true
    					loginForget(this['zhTelInfo']).then(res=>{
                            if(res.code == 0){
                                
                            }
                            this.submitLoading = false
                        }).catch(res => {
                            this.submitLoading = false
                        })
                    }
        		})
        	}else if(val){
				userUpdate(this.enrollInfo).then(res => {
					// this.$router.go(0)
					this.$store.dispatch('getUserInfo')
					userGetUserInfo({}).then(res=>{
						this.userinfodata=res
						this.zhTelInfo.phone = this.userinfodata.phone
					})
				})
			}else{
				this.enrollInfo = {
					// chineseName: '',
					// sex: '',
					// phone:null,
					// qq:null,
					// email:null,
					// documentType: null,
					// documentNo: null,
					id:this.$store.getters.userInfo.id,
				}
			}
		},
		sendCode() {
			this.$refs['zhTel'].validateField('phone', (valid) => {
			    if (!valid){
			        this.sendCodeLoading = true
			        loginGetCode({phone:this.zhTelInfo.phone}).then(res=>{})
			    }
			})
		}
    }
}
</script>

<style scoped>
    .menu{float: left;width: 170px;}
    .content{float: right;width: 1028px;}
	.content >>> .el-tabs__nav .el-tabs__item{ font-size: 16px;box-sizing: border-box;}
	.content >>> .el-tabs__nav .el-tabs__item:hover {color: #a22a22;}
	.content >>> .el-tabs__active-bar {background: #a22a22 ;}
	.content >>> .is-active {color: #a22a22;font-weight: bold;}
	.content >>> .el-form-item{margin-top: 10px;margin-bottom: 0;}
	.content  .buttons{margin-left: 25px;margin-top: 43px;}
	.userinfo .content  .getcode >>> button {margin-left: 20px;}
	.zh >>> .el-form-item{margin-bottom: 20px;}
</style>
